import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical.location')

/**
 * Names a location. One the merchant's locations list lacks reads by its id,
 * as the list did load; only a list that failed to load makes it unavailable.
 */
const locationNameOf = (
  id: number | null,
  names: ReadonlyMap<number, string>,
  namesFailed: boolean
): string => {
  if (id === null) return t('none')
  const name = names.get(id)
  if (name) return name
  return namesFailed ? t('unavailable') : t('by_id', { id })
}

export default locationNameOf
